export default "__VITE_ASSET__605cdaaa__"